/**
 * Created by qlong on 10/3/2016.
 */

export function addChart(chart){
    return {
        type: "ADD_CHART",
        payload: chart,
    }
}

export function changeIndicator(indicator){
    return {
        type: "CHANGE_INDICATOR",
        payload: indicator,
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/filteredLineChartActions.js
 **/